// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aeefebf7","909":"5aeab44d","948":"9a1b6329"}[chunkId] + ".chunk.js";
};